export const getIndex = (i, length) => {
    const rate = i % length;
    if (rate >= 0) {
        return rate;
    }
    return length + rate;
};
